import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PortalShell } from './components/shell/PortalShell';
import { ToastProvider } from './contexts/ToastContext';
import { ActivityPlanProvider } from './contexts/ActivityPlanContext';
import { PerfectDayPage } from './pages/PerfectDayPage';
import { PerfectWeekPage } from './pages/PerfectWeekPage';
import { ProgressPage } from './pages/ProgressPage';
import { ProspectsPage } from './pages/ProspectsPage';
import { PastClientsPage } from './pages/PastClientsPage';
import { ImportDataPage } from './pages/ImportDataPage';
import { MyLeadsPage } from './pages/MyLeadsPage';
import { LeadDetailPage } from './pages/LeadDetailPage';
import { MyRealtorsPage } from './pages/MyRealtorsPage';
import { RealtorDetailPage } from './pages/RealtorDetailPage';
import { MyPreApprovalsPage } from './pages/MyPreApprovalsPage';
import { MyLoansPage } from './pages/MyLoansPage';
interface AppProps {
  /** Start in the first-run experience, where the officer has not built a plan yet. */
  firstRunOnboarding?: boolean;
}
export function App({
  firstRunOnboarding = false
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="3mjq27fl7ksv2">
      <ToastProvider data-id="element-1" data-mp="3mj6jvxrnc2gi">
        <ActivityPlanProvider onboarded={!firstRunOnboarding} data-id="element-2" data-mp="3rcj31sdk3h1v">
          <PortalShell data-id="element-3" data-mp="3recedkz46pg7">
            <Routes data-id="element-4" data-mp="5ygolyg4xb6">
              <Route path="/" element={<PerfectDayPage data-id="element-6" data-mp="4n725ibkvc5" />} data-id="element-5" data-mp="67yhm9c7y5s" />
              <Route path="/plan" element={<PerfectWeekPage data-id="element-8" data-mp="2zllen0i82im7" />} data-id="element-7" data-mp="7ssnarqpf34" />
              <Route path="/progress" element={<ProgressPage data-id="element-10" data-mp="2zng32ospcsv1" />} data-id="element-9" data-mp="2zmo557bmuj1l" />
              <Route path="/prospects" element={<ProspectsPage data-id="element-12" data-mp="33n6yj5t6bx5w" />} data-id="element-11" data-mp="33m5e4aq9pybi" />
              <Route path="/past-clients" element={<PastClientsPage data-id="element-14" data-mp="38li77d7qg1mj" />} data-id="element-13" data-mp="33oi0d0326uud" />
              <Route path="/import" element={<ImportDataPage data-id="element-16" data-mp="3dkuwe4m2tksa" />} data-id="element-15" data-mp="38kgmsi4tu2s5" />
              <Route path="/leads" element={<MyLeadsPage data-id="element-18" data-mp="3dm5xtxs1ugg8" />} data-id="element-17" data-mp="3dlw6a5rcw18f" />
              <Route path="/leads/:leadId" element={<LeadDetailPage data-id="element-20" data-mp="nuhhkgf627t8" />} data-id="element-19" data-mp="nvj3jfxq0epq" />
              <Route path="/realtors" element={<MyRealtorsPage data-id="element-22" data-mp="sudmchvou39u" />} data-id="element-21" data-mp="nxn69ujvv7of" />
              <Route path="/realtors/:realtorId" element={<RealtorDetailPage data-id="element-24" data-mp="swgmvvugvest" />} data-id="element-23" data-mp="stc9c7v436ph" />
              <Route path="/pre-approvals" element={<MyPreApprovalsPage data-id="element-26" data-mp="34nbhsjeuzx5" />} data-id="element-25" data-mp="35oxgs1yt6tn" />
              <Route path="/loans" element={<MyLoansPage data-id="element-28" data-mp="3ubrgyizwqe3g" />} data-id="element-27" data-mp="3ud1ftael3qb5" />
            </Routes>
          </PortalShell>
        </ActivityPlanProvider>
      </ToastProvider>
    </BrowserRouter>;
}